import { Organization } from '@/types/organizations'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface organizationInitialState {
  organizations: Organization[]
}

const initialState: organizationInitialState = {
  organizations: [],
}

const setOrganizations = (
  state: organizationInitialState = initialState,
  action: PayloadAction<Organization[]>
) => {
  return {
    ...state,
    organizations: action.payload
  }
}

const reset = () => initialState

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganizations,
    reset
  }
})

export const organizationReducer = organizationSlice.reducer
export const organizationActions = organizationSlice.actions
